__turbopack_context__.v({
  "cta": "CoreSocialMediaEmbeds-module-scss-module__TDZUbG__cta",
  "description": "CoreSocialMediaEmbeds-module-scss-module__TDZUbG__description",
  "left": "CoreSocialMediaEmbeds-module-scss-module__TDZUbG__left",
  "main": "CoreSocialMediaEmbeds-module-scss-module__TDZUbG__main",
  "right": "CoreSocialMediaEmbeds-module-scss-module__TDZUbG__right",
});
